export default __webpack_public_path__ + "img/weibo.beb47bfc.svg";